(function () {
  'use strict';

  const header = document.querySelector('.krc18sep-header');
  if (!header) return;
  if (window.__KRC18SEP_HEADER_INITIALIZED__) return;
  window.__KRC18SEP_HEADER_INITIALIZED__ = true;

  // Open the existing desktop cart canvas instead of navigating to /cart.
  // The fallback keeps the link usable if the canvas is not rendered.
  document.addEventListener('click', function (event) {
    const cartAction = event.target.closest('.krc18sep-cart-action');
    if (!cartAction) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const cartCanvas = document.getElementById('desktop_cart');
    if (!cartCanvas) return;
    cartCanvas.classList.add('active');
    document.querySelector('.sidebar-overlay')?.classList.add('act');
    document.body.classList.add('cart_popup_opened');
    cartAction.setAttribute('aria-expanded', 'true');

    refreshCartDrawer();
  }, true);

  function updateCartCounts(cart) {
    const count = Number(cart?.item_count) || 0;

    document.querySelectorAll('.CartCount, #CartCountCavas, .cart-products-count span').forEach(function (element) {
      element.textContent = count;
    });

    document.querySelectorAll('.krc18sep-cart-action, .krc18sep-mobile-action[aria-label="Cart"]').forEach(function (cartAction) {
      let badge = cartAction.querySelector('.krc18sep-cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'krc18sep-cart-count';
          cartAction.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  async function refreshCartDrawer() {
    const cartCanvas = document.getElementById('desktop_cart');
    const cartInfo = document.getElementById('cart-info');
    if (!cartCanvas || !cartInfo) return;

    try {
      const root = getShopifyRoot();
      const cacheBust = '_krc=' + Date.now();
      const [cartResponse, markupResponse] = await Promise.all([
        fetch(root + 'cart.js?' + cacheBust, {
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        }),
        fetch(root + 'cart?view=json&' + cacheBust, {
          cache: 'no-store',
          headers: { Accept: 'text/html' }
        })
      ]);

      if (!cartResponse.ok || !markupResponse.ok) throw new Error('Cart refresh failed');
      const cart = await cartResponse.json();
      const markup = await markupResponse.text();

      updateCartCounts(cart);
      cartInfo.innerHTML = markup;
      cartCanvas.classList.toggle('item_count', cart.item_count > 0);
      cartInfo.querySelectorAll('.cart__mini-qty--input').forEach(function (input) {
        input.disabled = false;
      });
      document.dispatchEvent(new CustomEvent('cart:drawer:updated', { detail: { cart } }));
    } catch (error) {
      console.error('KRC cart drawer:', error);
    }
  }

  function closeCartDrawer() {
    document.getElementById('desktop_cart')?.classList.remove('active');
    document.querySelector('.sidebar-overlay')?.classList.remove('act');
    document.body.classList.remove('cart_popup_opened');
    document.querySelectorAll('.krc18sep-cart-action').forEach(function (action) {
      action.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('cart:updated', refreshCartDrawer);
  document.addEventListener('click', function (event) {
    if (event.target.closest('.close_cart') || event.target.closest('.sidebar-overlay')) {
      closeCartDrawer();
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCartDrawer();
  });

  async function changeCartLine(lineIndex, quantity) {
    const cartResponse = await fetch(getShopifyRoot() + 'cart.js', {
      headers: { Accept: 'application/json' }
    });
    if (!cartResponse.ok) throw new Error('Unable to read cart');
    const cart = await cartResponse.json();
    const item = cart.items[Number(lineIndex)];
    if (!item) throw new Error('Cart line not found');

    const response = await fetch(getShopifyRoot() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: item.key, quantity: Math.max(0, Number(quantity) || 0) })
    });
    if (!response.ok) throw new Error('Unable to update cart');
    await refreshCartDrawer();
  }

  document.addEventListener('click', function (event) {
    const removeButton = event.target.closest('#cart-info .remove-from-cart');
    const quantityButton = event.target.closest('#cart-info .cart__mini-qty');
    if (!removeButton && !quantityButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const product = event.target.closest('.ajaxcart__product');
    const input = product?.querySelector('.cart__mini-qty--input');
    const lineIndex = product?.getAttribute('data-line');
    if (!input || lineIndex === null) return;

    const current = Number(input.value) || 1;
    const next = removeButton
      ? 0
      : current + (quantityButton.classList.contains('cart__mini-qty--plus') ? 1 : -1);

    if (next < 0) return;
    input.disabled = true;
    product.classList.add('krc-cart-line-loading');
    changeCartLine(lineIndex, next).catch(function (error) {
      console.error('KRC cart line update:', error);
      input.disabled = false;
      product.classList.remove('krc-cart-line-loading');
    });
  }, true);

  document.addEventListener('change', function (event) {
    const input = event.target.closest('#cart-info .cart__mini-qty--input');
    if (!input) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const product = input.closest('.ajaxcart__product');
    const lineIndex = product?.getAttribute('data-line');
    if (lineIndex === null) return;
    input.disabled = true;
    product.classList.add('krc-cart-line-loading');
    changeCartLine(lineIndex, Math.max(0, Number(input.value) || 0)).catch(function (error) {
      console.error('KRC cart line update:', error);
      input.disabled = false;
      product.classList.remove('krc-cart-line-loading');
    });
  }, true);

  window.KRC18SEP_CART = {
    refresh: refreshCartDrawer,
    close: closeCartDrawer
  };

  const searchModal = header.querySelector('[data-krc18sep-search-modal]');
  const searchInput = header.querySelector('[data-krc18sep-search-input]');
  const searchResults = header.querySelector('[data-krc18sep-search-results]');
  const searchOpenButtons = header.querySelectorAll('[data-krc18sep-search-open]');
  const searchCloseButtons = header.querySelectorAll('[data-krc18sep-search-close]');

  if (!searchModal || !searchInput || !searchResults) return;

  let debounceTimer = null;
  let requestController = null;
  let requestSequence = 0;

  function openSearch() {
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('krc18sep-search-open');
    document.body.classList.add('krc18sep-no-scroll');

    window.setTimeout(function () {
      searchInput.focus();
      const length = searchInput.value.length;
      try {
        searchInput.setSelectionRange(length, length);
      } catch (error) {}
    }, 180);
  }

  function closeSearch() {
    searchModal.classList.remove('is-open');
    searchModal.setAttribute('aria-hidden', 'true');
    cancelSearchRequest();
    clearTimeout(debounceTimer);
    requestSequence++;
    document.documentElement.classList.remove('krc18sep-search-open');

    const mobileDrawer = header.querySelector('[data-krc18sep-mobile-drawer]');
    if (!mobileDrawer || !mobileDrawer.classList.contains('is-open')) {
      document.body.classList.remove('krc18sep-no-scroll');
    }
  }

  searchOpenButtons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      openSearch();
    });
  });

  searchCloseButtons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      closeSearch();
    });
  });

  function cancelSearchRequest() {
    if (requestController) {
      requestController.abort();
      requestController = null;
    }
  }

  function escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }

  function getImageUrl(product) {
    if (!product) return '';
    if (typeof product.image === 'string') return product.image;
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && typeof product.featured_image.url === 'string') return product.featured_image.url;
    return '';
  }

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function showEmptyState() {
    searchResults.classList.remove('is-loading');
    searchResults.innerHTML = `
      <div class="krc18sep-search-empty">
        Search for products, collections and more.
      </div>
    `;
  }

  function showLoadingState() {
    // If the grid already exists, dim it instead of destroying it.
    // This prevents the height from collapsing and breaking the layout.
    if (searchResults.querySelector('.krc18sep-search-products')) {
      searchResults.classList.add('is-loading');
    } else {
      searchResults.innerHTML = `
        <div class="krc18sep-search-loading">
          Searching...
        </div>
      `;
    }
  }

  searchInput.addEventListener('input', function () {
    const query = this.value.trim();
    clearTimeout(debounceTimer);
    cancelSearchRequest();

    const currentSequence = ++requestSequence;

    if (!query) {
      showEmptyState();
      return;
    }

    showLoadingState();

    debounceTimer = setTimeout(function () {
      performSearch(query, currentSequence);
    }, 300);
  });

  async function performSearch(query, currentSequence) {
    if (currentSequence !== requestSequence) return;
    
    cancelSearchRequest();
    requestController = new AbortController();

    try {
      const root = getShopifyRoot();
      const url = root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=hide';
      
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        signal: requestController.signal
      });

      if (currentSequence !== requestSequence) return;
      if (!response.ok) throw new Error('Search request failed');
      
      const data = await response.json();
      if (currentSequence !== requestSequence) return;

      renderSearchResults(data, query);

    } catch (error) {
      if (error.name === 'AbortError') return;
      if (currentSequence !== requestSequence) return;
      console.error('KRC Search:', error);
      searchResults.classList.remove('is-loading');
      searchResults.innerHTML = `
        <div class="krc18sep-search-empty">
          Something went wrong. Please try again.
        </div>
      `;
    } finally {
      if (currentSequence === requestSequence) {
        requestController = null;
      }
    }
  }

  function renderSearchResults(data, query) {
    searchResults.classList.remove('is-loading');
    
    const products = data?.resources?.results?.products || [];
    const visibleProducts = products.slice(0, 5);

    if (visibleProducts.length === 0) {
      searchResults.innerHTML = `
        <div class="krc18sep-search-empty">
          No products found for "<strong>${escapeHtml(query)}</strong>".
        </div>
      `;
      return;
    }

    const productMarkup = visibleProducts.map(product => {
      const image = getImageUrl(product);
      const title = product.title || '';
      const url = product.url || '#';
      const price = product.price || '';

      return `
        <a class="krc18sep-search-product" href="${url}">
          <div class="krc18sep-search-product-image">
            ${image ? `<img src="${image}" alt="${escapeHtml(title)}">` : ''}
          </div>
          <div class="krc18sep-search-product-title">${escapeHtml(title)}</div>
          ${price ? `<div class="krc18sep-search-product-price">${escapeHtml(price)}</div>` : ''}
        </a>
      `;
    }).join('');

    const root = getShopifyRoot();
    const viewAllUrl = root + 'search?q=' + encodeURIComponent(query);

    searchResults.innerHTML = `
      <div class="krc18sep-search-result-title">PRODUCTS</div>
      <div class="krc18sep-search-products">${productMarkup}</div>
      <a href="${viewAllUrl}" class="krc18sep-search-view-all">SEE ALL RESULTS →</a>
    `;
  }

  searchInput.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeSearch();
      return;
    }
    if (event.key === 'Enter') {
      clearTimeout(debounceTimer);
      cancelSearchRequest();
    }
  });

  const mobileDrawer = header.querySelector('[data-krc18sep-mobile-drawer]');
  const mobileOverlay = header.querySelector('[data-krc18sep-mobile-overlay]');
  const mobileOpen = header.querySelector('[data-krc18sep-mobile-open]');
  const mobileClose = header.querySelector('[data-krc18sep-mobile-close]');

  function openMobileMenu() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.add('is-open');
    mobileDrawer.setAttribute('aria-hidden', 'false');
    if (mobileOverlay) mobileOverlay.classList.add('is-visible');
    if (mobileOpen) mobileOpen.setAttribute('aria-expanded', 'true');
    document.body.classList.add('krc18sep-no-scroll');
  }

  function closeMobileMenu() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('is-open');
    mobileDrawer.setAttribute('aria-hidden', 'true');
    if (mobileOverlay) mobileOverlay.classList.remove('is-visible');
    if (mobileOpen) mobileOpen.setAttribute('aria-expanded', 'false');
    if (!searchModal.classList.contains('is-open')) {
      document.body.classList.remove('krc18sep-no-scroll');
    }
  }

  if (mobileOpen) mobileOpen.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  const mobileExpandButtons = header.querySelectorAll('[data-krc18sep-mobile-expand]');
  mobileExpandButtons.forEach(button => {
    button.addEventListener('click', function () {
      const parent = this.closest('.krc18sep-mobile-nav-item');
      if (!parent) return;
      const expanded = parent.classList.toggle('is-expanded');
      this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (searchModal.classList.contains('is-open')) closeSearch();
    closeMobileMenu();
  });

})();
